import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Swipe, SwipeItem } from 'vant';
import { Loading } from 'vant';
import { Collapse, CollapseItem } from 'vant';
import { Popup } from 'vant';
import { Dialog } from 'vant';
import { Toast } from 'vant'

import mslNav from "./components/mslNav";
import mslFooter from "./components/mslFooter";
import mslMsg from "./components/mslMsg";
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)


Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Loading);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Dialog);
Vue.use(Toast);
Vue.component('mslNav', mslNav);
Vue.component('mslFooter', mslFooter);
Vue.component('mslMsg', mslMsg);
Vue.use(Popup);

// 全局调用mixin
Vue.mixin({
  data() {
    return {

    }
  },
  methods: {
    errToast(str) {
      if (!str) str = '获取数据失败，请刷新重试'

      this.$dialog.alert({
        title:'提示',
        message:str,
        confirmButtonColor:'red'
      })
    },
    successToast(str) {
      this.$dialog.alert({
        title:'提示',
        message:str,
        confirmButtonColor:'green'
      })
    },
    checkPhone(phones) {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(phones)) {
        return false;
      } else {
        return true;
      }
    },
    checkEmail(mail) {
      var myreg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/;
      if (!myreg.test(mail)) {
        return false;
      } else {
        return true;
      }
    }

  },
  mounted() {
  }
})


/**
 * 判断是否为移动设备，是，则跳转到移动端的路径
 */
// router.beforeEach((to, from, next) => {
//   if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
//     console.log('切换初识化， .......');
//     // window.location.href = '/m_index.html#/'
//     console.log(!!(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)), '切换');
//     return
//   }
//   next()
// })


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
